// Copyright (c) 2022 by Move Closer

import { computed, PropType, ref } from '@vue/composition-api'

import { canBeDisabledProp } from '../../../composables'
import { ComponentObjectPropsOptions, Emit } from '../../../vue-api'

import { DropdownItemProps, DropdownItemType, UseDropdownItemProvides } from './DropdownItem.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const dropdownItemProps: ComponentObjectPropsOptions<DropdownItemProps> = {
  ...canBeDisabledProp,

  /**
   * @see DropdownItemProps.icon
   */
  icon: {
    type: String,
    required: false
  },

  /**
   * @see DropdownItemProps.label
   */
  label: {
    type: String,
    required: false
  },

  /**
   * @see DropdownItemProps.onClick
   */
  onClick: {
    type: Function,
    required: false
  },

  /**
   * @see DropdownItemProps.type
   */
  type: {
    type: String as PropType<DropdownItemType>,
    required: false,
    default: 'item'
  }
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const useDropdownItem = (props: DropdownItemProps, emit: Emit): UseDropdownItemProvides => {
  /**
   * @see UseDropdownItemProvides.tag
   */
  const tag = computed<string>(() => {
    return props.type === DropdownItemType.Item ? 'button' : 'span'
  })

  /**
   * @see UseDropdownItemProvides.isLoading
   */
  const isLoading = ref<boolean>(false)

  /**
   * @see UseDropdownItemProvides._onClick
   */
  const _onClick = () => {
    if (typeof props.onClick !== 'function') {
      emit('close')
      return
    }

    const fnCall = props.onClick()

    if (fnCall instanceof Promise) {
      isLoading.value = true

      fnCall.finally(() => {
        isLoading.value = false
        emit('close')
      })

      return
    }
    emit('close')
  }

  return { tag, isLoading, _onClick }
}
